(ns app.front.ui.autofocus
  (:require [reagent.core :as r]))

(defn autofocus
  "Wrap a component (usually an input field) with this component to control
   its focus with the :should-focus? parameter.

   The element given as :ref parameter will be focused every time the
   :should-focus? parameter changes to any truthy value that differs from
   its previous value."
  [_ & _]
  (r/create-class
    {:component-did-mount
     (fn [this]
       (let [{:keys [ref should-focus?]} (r/props this)]
         (when-let [target (and should-focus? @ref)]
           (.focus target))))
     :component-did-update
     (fn [this [_ old-props] & _]
       (let [{:keys [ref should-focus?]} (r/props this)]
         (when (and should-focus?
                    (not= should-focus? (-> old-props :should-focus?)))
           (when-let [target @ref]
             (.focus target)))))
     :reagent-render
     (fn [_ & children]
       (into [:<>] children))}))
